var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._l((_vm.assets),function(asset,index){return _c('asset-item',{key:(index + "-" + (asset.asset_id)),staticClass:"mb-3",attrs:{"expand-asset":_vm.expandAsset,"asset":asset},on:{"expand":_vm.handleExpand}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }